export enum OrderNoteType {
  InternalNote,
  ExternalNote,
}
